// create enum with two values opted_in and opted_out

export enum EventConsentStatus {
    OPTED_IN = 'OPTED_IN',
    OPTED_OUT = 'OPTED_OUT'
}